var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cubby_enabled)?_c('AdminResourceUsageNew'):_c('AdminResourceUsageLegacy',{attrs:{"course_code":_vm.course_code}})}
var staticRenderFns = []

export { render, staticRenderFns }